import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=60b3788c&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Products.vue?vue&type=style&index=0&id=60b3788c&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "60b3788c",
  null
  ,true
)

export default component.exports